export default __webpack_public_path__ + "static/media/footer.48da0015.jpeg";